import { Link, useSearchParams } from "react-router-dom";
import { Clock, CheckCircle } from "lucide-react";
import { useEffect, useState } from "react";

export default function SubscriptionSuccess() {
  const [searchParams] = useSearchParams();
  const [returnTo, setReturnTo] = useState<string>('/');

  useEffect(() => {
    // Check for returnTo in localStorage (from checkout data)
    const storedCheckoutData = localStorage.getItem('subscriptionCheckout');
    if (storedCheckoutData) {
      try {
        const data = JSON.parse(storedCheckoutData);
        if (data.returnTo) {
          setReturnTo(data.returnTo);
        }
      } catch (err) {
        console.error('Error parsing checkout data:', err);
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-white flex items-center justify-center py-12 px-4">
      <div className="max-w-2xl w-full bg-white rounded-3xl shadow-2xl p-8 md:p-12 text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-green-500" />
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-textDark mb-4">
          ชำระเงินสำเร็จ!
        </h1>

        <p className="text-lg text-textLight mb-4">
          ขอบคุณที่เลือกใช้บริการ EduMi
        </p>

        <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-2xl p-6 mb-8 border-2 border-yellow-300">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Clock className="w-6 h-6 text-yellow-600 animate-spin" />
            <h3 className="text-lg font-bold text-gray-900">รอการอนุมัติจาก Admin</h3>
          </div>
          <p className="text-gray-700 mb-2">
            การชำระเงินของคุณกำลังรอการอนุมัติจากผู้ดูแลระบบ
          </p>
          <p className="text-sm text-gray-600">
            คุณจะสามารถใช้งานฟีเจอร์ทั้งหมดได้หลังจากได้รับการอนุมัติ
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/admin/unified-payment-approval">
            <button className="w-full sm:w-auto bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-8 py-4 rounded-xl font-bold hover:shadow-xl transition-all duration-300 transform hover:scale-105">
              ไปที่ Admin Dashboard (รออนุมัติ)
            </button>
          </Link>
          <Link to={returnTo}>
            <button className="w-full sm:w-auto bg-white border-2 border-gray-200 text-textDark px-8 py-4 rounded-xl font-semibold hover:bg-gray-50 transition-all duration-300">
              {returnTo === '/subscription/storage-addon' ? 'กลับไปหน้า Add-on Storage' : 'กลับหน้าหลัก'}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
